import { UserType } from '../../constant';

const userTypeToString: Map<UserType, string> = new Map<UserType, string>();
userTypeToString.set(UserType.公司管理员, '公司管理员');
userTypeToString.set(UserType.普通用户, '普通用户');
userTypeToString.set(UserType.超级管理员, '系统管理员');

export default userTypeToString;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/Language/userTypeToString/index.ts